import Icon from 'veui/components/Icon'

Icon.register({
  'scan-exchange': {
    paths: [
      {
        d: 'M640 447a96.11 96.11 0 0196 96 32 32 0 01-64 0 32 32 0 00-32-32H512v19.2a13 13 0 01-6.34 11.29 11.38 11.38 0 01-12.32-.64l-72-51.2a13.29 13.29 0 010-21.3l72-51.2a11.38 11.38 0 0112.32-.64A13 13 0 01512 427.8V447zm90.66 213.77l-72-51.6a11.28 11.28 0 00-12.32-.64A13.06 13.06 0 00640 619.9V639H512a32 32 0 01-32-32 32 32 0 00-64 0 96.11 96.11 0 0096 96h128v20.1a13.06 13.06 0 006.34 11.37 11.27 11.27 0 0012.32-.64l72-51.6a13.45 13.45 0 000-21.46zM672 320a32 32 0 00-32-32H128a32 32 0 000 64h512a32 32 0 0032-32zM480 128h160v64a32 32 0 0064 0V96a32 32 0 00-32-32H480a32 32 0 000 64zM96 224a32 32 0 0032-32v-64h160a32 32 0 000-64H96a32 32 0 00-32 32v96a32 32 0 0032 32zm192 416H128V448a32 32 0 00-64 0v224a32 32 0 0032 32h192a32 32 0 000-64z'
      }
    ],
    width: '768',
    height: '768'
  }
})
